import { AppRoutes } from '../../App/routes';

export const devAccountDetailRoute = `${AppRoutes.CONSOLE_BASE_ROUTE}/account/detail`;
